export default __webpack_public_path__ + "static/media/call-icon.6b26dd1c.svg";